import { useTranslation } from "react-i18next";
import { localDateTime } from "../../../lib/datetime";
import { BellRing, ShieldCheck } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

export const AlertsHistoryCard = ({ data, onOpen }) => {
  const { t } = useTranslation();
  if (!data) return null;

  return (
    <NeuCard
      data-testid="system-alerts-card"
      onClick={onOpen}
      className="cursor-pointer transition-transform duration-300 hover:-translate-y-0.5"
    >
      <p className="label-xs flex items-center gap-2">
        <BellRing className="h-4 w-4 text-primary" /> {t("system.alerts")}
      </p>

      {data.rules.length ? (
        <ul className="mt-4 grid gap-2 sm:grid-cols-3" data-testid="system-alert-rules">
          {data.rules.map((r) => (
            <li key={r.rule} className="rounded-2xl bg-background p-3 shadow-neu-sm">
              <p className="text-[10px] font-bold text-muted-foreground">{t(`system.rule_${r.rule}`, r.rule)}</p>
              <p className="mt-1 font-mono text-lg font-black text-amber-500 num">
                {r.times}×
              </p>
              <p className="font-mono text-[10px] text-muted-foreground num">
                {localDateTime(r.last_at)}
              </p>
            </li>
          ))}
        </ul>
      ) : null}

      {!data.events.length ? (
        <p className="mt-4 flex items-center gap-2 text-sm text-muted-foreground" data-testid="system-alerts-empty">
          <ShieldCheck className="h-4 w-4 text-primary" /> {t("system.noAlerts")}
        </p>
      ) : (
        <ul className="mt-4 grid gap-1.5" data-testid="system-alert-events">
          {data.events.map((e, i) => (
            <li
              key={`${e.rule}-${i}`}
              className="flex items-center justify-between gap-3 rounded-xl bg-background px-3 py-2 text-[11px] shadow-neu-sm"
            >
              <span className="truncate font-bold">{t(`system.rule_${e.rule}`, e.rule)}</span>
              <span className="shrink-0 font-mono text-muted-foreground" dir="ltr">
                {e.value}% / {e.limit}% · {localDateTime(e.at)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </NeuCard>
  );
};
